import { getAuthorByName } from "@/data/authors";
// import type { PaddingSize } from "../content-section/index.marko";
import type { DesignQuote } from "@/data/design-disciplines";
import s from "./style.module.css";
export interface Input extends Marko.HTML.Section {
    quotes: DesignQuote[];
    // paddingBlock?: (PaddingSize | null)[];
    // paddingInline?: boolean;
}

<evo-carousel class=s.carousel>
    <@items>
        <for|quote| of=input.quotes>
            <const/author=getAuthorByName(quote.author)>
            <div class=s.card>
                <div class=s.content>
                    <avatar user=author/>
                    <p>${quote.text}</p>
                </div>
            </div>
        </for>
    </@items>
</evo-carousel>
